import LiveTVChannelList from '../../components/LiveTV/LiveTVChannelList'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { channels } from '../../graphqlDic'
import { graphql, compose } from 'react-apollo'

export default compose(
    graphql(channels, {
        name: 'channels'
    })
)(withRouter(
    connect(
        null,
        null
    )(LiveTVChannelList)
));



// WEBPACK FOOTER //
// ./src/containers/LiveTV/LiveTVChannelList.js